module.exports = {
  "country": "YU",
  "artist": "Riva",
  "song": "Rock me",
  "year": "1989",
  "place": "1",
  "spotify": "4D15RxzIHzkZJH6zpaLbYL"
};